(function () {
    document.querySelectorAll(".social-media-buttons").forEach(smb => {
        let displayShare = false; 
        const btn = smb.querySelector("button")       
        const smLinks = smb.querySelectorAll(".social-media")
        const pageShare = smb.querySelectorAll(".social-media-share")
        btn.addEventListener("click", (e) => {
            e.preventDefault()
            if (displayShare) {
                smLinks.forEach(p => {
                    p.style.display = ""
                })
                pageShare.forEach(p => {
                    p.style.display = "none"
                })
            } else {
                smLinks.forEach(p => {
                    p.style.display = "none"
                })
                pageShare.forEach(p => {
                    p.style.display = ""
                })
            }
            displayShare = !displayShare;
        })
    })
})();
